import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from 'primereact/tabview';
import AllDocuments from "./listingDocs/allDocuments";
import MyDocuments from "./listingDocs/myDocuments";
import { Container } from "react-bootstrap";
import { ApiURLs, API_BASE_URL } from "../../../common/url";
import { deleteDocuments, downloadDocuments } from "../../../store/documents/documentSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppToast } from "../../../lib/toast";
import { getConfiguredLabel } from "../../../common/commonHelper";
import { allDocumentsHeading, dataDeleted, docDeletedMessage, docDownloadingMessage, docDownloadingTitle, documents, DocumentsPage, downloadProgressMessage, downloadSuccessfulMessage, downloadWarningMessage, HeaderMenu, myDocumentsHeading, warning } from "../../../common/labelConstants";
import { DocumentDownloadProgress } from "./docDownloadProgress";
import { setButtonsText as setBannerDataJsx  } from "../../../store/banner/bannerSlice";
import { UploadButton } from "../uploadButton";
import { usePermissions } from "../../../hooks/usePermissions";
import { setChartDataEditted } from "../../../store/charts/chartSlice";
import { PasswordResetPopup } from "../admin/adminListing/passwordReset";

export const Documents = (props) => {
    const loginUserInfo = useSelector(state => state.auth.userInfo) || {};
    const [showPasswordResetPopup, setShowPasswordResetPopup] = useState((typeof loginUserInfo.loginKeyReset !== 'undefined') ? (!loginUserInfo.loginKeyReset) : false )
    const slbSearchConfig = window.slbConfig;
    const [showDownloadProgress, setShowDownloadProgress] = useState(false)
    const dispatch = useDispatch();
    const permissions = usePermissions();
    let refreshChart = useSelector( x => x.chart.isDataEditted)

    const bannerContent = {
        tabName: getConfiguredLabel(HeaderMenu,documents),
        actionsJSX: <>
            <div className='cancel-save-btns'>
                {
                    permissions.Edit
                        ? <UploadButton />
                        : null
                }</div>
        </>,
        hideBreadcrumb: true,
        headerClassName: "document-header-textarea"

    }

    useEffect(() => {
        dispatch(setBannerDataJsx(bannerContent))
        return () => {
            dispatch(setBannerDataJsx(null))
        }
    }, [])


    const handleDownload = (selectedRows, setSelectedRows) => {
        const payload = {
            clientId: slbSearchConfig.accountId,
            downloadInfo: { ids: selectedRows.map(s => s._id) }
        }
        if (Array.isArray(selectedRows) && selectedRows.length > 0) {
            setShowDownloadProgress(true)
            dispatch(downloadDocuments(payload))
                .then((resp) => {
                    if (typeof setSelectedRows === 'function') {
                        setSelectedRows([])
                    }
                    setShowDownloadProgress(false)

                })
        }
        else {
            AppToast.Toast.warning({ title:getConfiguredLabel(DocumentsPage, warning)  , message: getConfiguredLabel(DocumentsPage, downloadWarningMessage) })
        }

    }


    const handleDeleteDoc = (rows, refresh, showDeletePopup) =>{
        const ids = Array.isArray(rows) ? rows.map(x => x._id) : []
        if(ids.length > 0)
          dispatch(deleteDocuments({clientId: slbSearchConfig.accountId , ids: ids})).then((resp)=>{
              if(typeof refresh === 'function'){
                refresh()
              }
              if(typeof showDeletePopup === 'function'){
                showDeletePopup(false)
              }
              dispatch(setChartDataEditted(!refreshChart))
              AppToast.Toast.success({title: getConfiguredLabel(DocumentsPage, dataDeleted), message: getConfiguredLabel(DocumentsPage, docDeletedMessage)})    
          })
      }



    return (<div className="upload_documents">
        <div className="slb-container-fluid">
            <TabView>
                <TabPanel header={getConfiguredLabel(DocumentsPage, allDocumentsHeading)}>
                    <AllDocuments  handleDeleteDoc={handleDeleteDoc}  handleDownloadFile={handleDownload}
                    />
                </TabPanel>
                <TabPanel header={getConfiguredLabel(DocumentsPage, myDocumentsHeading)}>
                    <MyDocuments handleDeleteDoc={handleDeleteDoc} handleDownloadFile={handleDownload}
                    />
                </TabPanel>
            </TabView>
        </div>
        {showPasswordResetPopup && (
        <PasswordResetPopup
          user={loginUserInfo}
          title="Reset Password"
          show={showPasswordResetPopup}
          setShowPopup={setShowPasswordResetPopup}
          firstReset={true}
        />
      )}
        <DocumentDownloadProgress show={showDownloadProgress} title={getConfiguredLabel(DocumentsPage, docDownloadingTitle)} message={getConfiguredLabel(DocumentsPage, docDownloadingMessage)} />
    </div>)
}